import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export const MODULE_LABELS = {
  financeiro: "Financeiro",
  fiscal: "Fiscal",
  estoque: "Estoque (compras, fornecedores, balcão)",
  crm: "CRM (lembretes, funil, pós-venda, satisfação, clube)",
  rh: "RH",
  patio: "Pátio / Modo TV",
  agendamento: "Agendamento",
  relatorios: "Relatórios (painel, equipe, rentabilidade)",
  checklist: "Checklist técnico",
  assistente: "Assistente de IA",
};

export function ShopModulesEditor({ shopId, initial, onSaved, waAllowed, onWaSaved, planModules }) {
  const [mods, setMods] = useState(initial || {});
  const [wa, setWa] = useState(!!waAllowed);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setMods(initial || {}); }, [initial]);
  useEffect(() => { setWa(!!waAllowed); }, [waAllowed]);
  const toggleWa = async (v) => {
    setWa(v); setBusy(true);
    try { await api.put(`/admin/shops/${shopId}/whatsapp-auto`, { allowed: v }); onWaSaved?.(v); toast.success(v ? "WhatsApp automático liberado" : "WhatsApp automático bloqueado"); }
    catch (e) { setWa(!v); toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  const toggle = async (key, v) => {
    const next = { ...mods, [key]: v };
    setMods(next);
    setBusy(true);
    try {
      const { data } = await api.put(`/admin/shops/${shopId}/modules`, { modules: next });
      onSaved?.(data.modules);
      toast.success(v ? "Módulo ligado" : "Módulo desligado — nada foi apagado");
    } catch (e) { setMods(mods); toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };
  return (
    <fieldset data-testid="shop-modules" className="rounded-xl border border-fuchsia-900/50 bg-fuchsia-950/10 p-4 space-y-2">
      <legend className="text-[11px] font-mono-caps text-fuchsia-300 px-2">Módulos (só super admin)</legend>
      <p className="text-[11px] text-zinc-500 -mt-1">OS e Clientes ficam sempre ligados. Desligar esconde o módulo do menu e bloqueia alterações; nada é apagado e religar volta tudo.</p>
      <ul className="space-y-1.5">
        {Object.entries(MODULE_LABELS).map(([k, label]) => (
          <li key={k} className="flex items-center justify-between rounded-md border border-zinc-800 bg-zinc-950/40 px-3 py-2 text-sm">
            <span className="text-zinc-200">{label}{planModules && (mods[k] !== false) !== planModules.includes(k) && <span data-testid={`shop-module-${k}-exception`} className="ml-2 rounded-full border border-amber-700 px-1.5 text-[10px] font-bold uppercase text-amber-300">exceção</span>}</span>
            <Switch data-testid={`shop-module-${k}`} checked={mods[k] !== false} onCheckedChange={(v) => toggle(k, v)} disabled={busy} />
          </li>
        ))}
        <li className="flex items-center justify-between rounded-md border border-emerald-900/60 bg-emerald-950/20 px-3 py-2 text-sm">
          <span className="text-emerald-200">WhatsApp automático (adicional)</span>
          <Switch data-testid="shop-wa-auto-allowed" checked={wa} onCheckedChange={toggleWa} disabled={busy} />
        </li>
      </ul>
      {busy && <Loader2 className="h-3.5 w-3.5 animate-spin text-fuchsia-300" />}
    </fieldset>
  );
}
